<template>
  <div class="basic_wrap wallet-ledger-page">
    <div class="wallet-header">
      <div
        class="wallet-back"
        @click="$router.back()"
      />
      <div class="wallet-title">
        {{ $t('moneybag.myWallet') }}
      </div>
      <div class="wallet-filter">
        <van-icon
          name="filter-o"
          size="16"
        />
      </div>
    </div>
    <section class="wallet-overview">
      <div class="wallet-balance">
        <p class="wallet-available">
          {{ $t('invest.availableBalance') }}
        </p>
        <p class="wallet-amount">
          {{ utils_moneyMark() }}{{ funds }}
        </p>
      </div>
      <div class="wallet-actions">
        <div
          class="wallet-action wallet-action-primary"
          @click="$router.push('/pay')"
        >
          {{ $t('user.withdraw') }}
        </div>
        <div
          class="wallet-action wallet-action-secondary"
          @click="$router.push('/invest')"
        >
          {{ $t('moneybag.recharge') }}
        </div>
      </div>
    </section>

    <van-empty
      v-if="listShow"
      :description="$t('moneybag.detailsEmpty')"
    />
    <div
      v-if="data && !listShow"
      class="wallet-ledger-list"
    >
      <div
        v-for="item in visibleData"
        :key="item.id || item.time + '-' + item.money"
        class="wallet-entry"
      >
        <div class="wallet-entry-copy">
          <p class="wallet-entry-title">
            {{ item[lang] }}
          </p>
          <p class="wallet-entry-time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="wallet-entry-amount"
          :class="item.type =='1'?'':'del'"
        >
          {{ item.type =='1' ? utils_moneyMark() + ' ' + item.money : '-' + utils_moneyMark() + ' ' + item.money }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "Moneybag",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: null,
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                frozen: 0,
                mymoney: 0,
                userName:''
            };
        },
        computed: {
            visibleData() {
                if (!Array.isArray(this.data)) {
                    return [];
                }
                return this.data.filter(item => item && item.show !== 0);
            }
        },
        created() {
			this.$parent.footer('user');
        },
        mounted() {
            Fetch('/user/funds').then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                for (var i in r.data.reason) {
                    switch (i) {
                        case "1":
                            r.data.reason[i] = this.$t('moneybag.recharge');
                            break;
                        case "2":
                            r.data.reason[i] = this.$t('moneybag.withdraw');
                            break;
                        case "3":
                            r.data.reason[i] = this.$t('moneybag.give');
                            break;
                        case "4":
                            r.data.reason[i] = this.$t('moneybag.signIn');
                            break;
                        case "5":
                            r.data.reason[i] = this.$t('moneybag.share');
                            break;
                        case "6":
                            r.data.reason[i] = this.$t('moneybag.purchase');
                            break;
                        case "7":
                            r.data.reason[i] = this.$t('moneybag.redPacket');
                            break;
                        case "8":
                            r.data.reason[i] = this.$t('moneybag.reward');
                            break;
                        case "9":
                            r.data.reason[i] = this.$t('moneybag.welfare');
                            break;
                        case "10":
                            r.data.reason[i] = this.$t('moneybag.invite');
                            break;
                        case "11":
                        case "12":
                            r.data.reason[i] = this.$t('moneybag.income');
                            break;
                        default:
                            break;
                    }
                    this.option.push({
                        text: r.data.reason[i],
                        value: i
                    })
                }
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = 1*r.data.money + 1*r.data.wx_bankbz;
                this.mymoney = r.data.mymoney;
                this.frozen = r.data.basemoney;
                this.userName = r.data.username;
				this.listd(1);
            })
        },
        methods: {
			listd(type){
				var dataf = this.data;
				this.data = null;
				if(dataf && dataf.length>0){
					if(type==1){
						for(let index=0;index<dataf.length;index++){
							dataf[index].show = 1;
						}
					}else if(type==2){
						for(let index=0;index<dataf.length;index++){
							if(dataf[index].reason_type !=3 && dataf[index].reason_type !=4){
								dataf[index].show = 1;
							}else{
								dataf[index].show = 0;
							}
						}
					}else{
						for(let index=0;index<dataf.length;index++){
							if(dataf[index].reason_type ==3 || dataf[index].reason_type ==4){
								dataf[index].show = 1;
							}else{
								dataf[index].show = 0;
							}
						}
					}
				}
				this.data = dataf;
			},
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
@coral: #ff385c;
@ink: #222222;
@muted: #717171;
@surface: #ffffff;

.wallet-ledger-page {
  min-height: 100vh;
  padding-bottom: 86px;
  box-sizing: border-box;
  overflow-x: hidden;
  color: @ink;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 14px;
}

.wallet-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 58px;
  box-sizing: border-box;
  border-bottom: 1px solid #f0e8e8;
  background: @surface;
}

.wallet-back {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 56px;
  height: 100%;
  cursor: pointer;
}

.wallet-back::after {
  position: absolute;
  top: 50%;
  left: 22px;
  width: 11px;
  height: 11px;
  border-left: 2px solid @ink;
  border-bottom: 2px solid @ink;
  content: '';
  transform: translateY(-50%) rotate(45deg);
}

.wallet-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 58px;
  padding: 8px 62px;
  box-sizing: border-box;
  color: @ink;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  overflow-wrap: anywhere;
}

.wallet-filter {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 100%;
  color: #605a61;
}

.wallet-overview {
  position: relative;
  overflow: hidden;
  margin: 18px 16px 16px;
  padding: 22px;
  border-radius: 20px;
  background: linear-gradient(125deg, @coral 0%, #eb2857 62%, #d91752 100%);
  box-shadow: 0 16px 32px rgba(239, 47, 88, .18);
  color: #fff;
}

.wallet-overview::after {
  position: absolute;
  top: -58px;
  right: -68px;
  width: 194px;
  height: 194px;
  border: 1px solid rgba(255, 255, 255, .2);
  border-radius: 50%;
  box-shadow: 0 0 0 24px rgba(255, 255, 255, .05);
  content: '';
  pointer-events: none;
}

.wallet-balance,
.wallet-actions {
  position: relative;
  z-index: 1;
}

.wallet-available {
  margin: 0;
  color: rgba(255, 255, 255, .92);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.wallet-amount {
  margin: 9px 0 0;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wallet-actions {
  display: flex;
  gap: 10px;
  margin-top: 22px;
}

.wallet-action {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 46px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 12px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.wallet-action-primary {
  border-color: #fff;
  background: #fff;
  color: #d91d51;
}

.wallet-action-secondary {
  background: rgba(255, 255, 255, .1);
}

.wallet-ledger-list {
  margin: 0 16px;
}

.wallet-entry {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 74px;
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid #eeeae8;
  border-radius: 16px;
  box-sizing: border-box;
  background: @surface;
  box-shadow: 0 7px 22px rgba(33, 33, 33, .045);
}

.wallet-entry-copy {
  flex: 1 1 0;
  min-width: 0;
}

.wallet-entry-title {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: @ink;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.wallet-entry-time {
  margin: 6px 0 0;
  color: @muted;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wallet-entry-amount {
  flex: 0 1 auto;
  max-width: 44%;
  min-width: 0;
  color: @coral;
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.3;
  text-align: right;
  overflow-wrap: anywhere;
}

.wallet-entry-amount.del {
  color: #277a5d;
}

/deep/ .van-empty {
  margin: 0 16px;
  border: 1px solid #eeeae8;
  border-radius: 16px;
  background: @surface;
  box-shadow: 0 7px 22px rgba(33, 33, 33, .045);
}

/deep/ .van-empty__description {
  color: @muted;
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 360px) {
  .wallet-overview {
    margin-right: 12px;
    margin-left: 12px;
    padding: 18px;
  }

  .wallet-ledger-list {
    margin-right: 12px;
    margin-left: 12px;
  }

  .wallet-entry {
    padding-right: 14px;
    padding-left: 14px;
  }
}
</style>
